

import { useRouter } from '@/lib/navigation';
import { FileX, ArrowLeft } from "lucide-react";

interface QuotationNotFoundProps {
  error?: string;
}

export default function QuotationNotFound({ error }: QuotationNotFoundProps) {
  const router = useRouter();

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center max-w-md mx-auto p-6">
        <div className="flex justify-center mb-4">
          <div className="p-3 bg-red-100 rounded-full">
            <FileX className="w-8 h-8 text-red-600" />
          </div>
        </div>
        
        <h2 className="text-xl font-semibold text-stone-900 mb-2">
          Quotation Not Found
        </h2>
        
        <p className="text-stone-600 mb-6">
          {error || "The quotation you're looking for doesn't exist or has been removed."}
        </p>
        
        <div className="flex gap-3 justify-center">
          <button
            onClick={() => router.back()}
            className="flex items-center gap-2 px-4 py-2 bg-stone-200 text-stone-700 rounded-lg hover:bg-stone-300 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </button>
          
          <button
            onClick={() => router.push("/quotations")}
            className="px-4 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors"
          >
            All Quotations
          </button>
        </div>
      </div>
    </div>
  );
}
